/******************************************************************************** 
    Setup Visible Section Detection
**********************************************************************************/

// Section visibility detection - ONLY handles .visible-section class management
document.addEventListener('DOMContentLoaded', function() {
    // Function to detect when sections are visible and add/remove .visible-section class
    function initSectionVisibilityDetection() {
        const sections = document.querySelectorAll('.shopify-section');
        
        if (sections.length === 0) return;
        
        // Create intersection observer for section visibility
        const sectionObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const section = entry.target;
                
                if (entry.isIntersecting) {
                    // Section is visible - add visible class
                    section.classList.add('visible-section');
                } else {
                    // Section is not visible - remove visible class
                    section.classList.remove('visible-section');
                }
            });
        }, {
            threshold: 0.3, // Trigger when 30% of section is visible
            rootMargin: '0px'
        });
        
        // Observe all sections
        sections.forEach(section => {
            sectionObserver.observe(section);
        });
    }
    
    // Initialize the section visibility detection
    initSectionVisibilityDetection();
});



/******************************************************************************** 
    Format NAD+ Text to NAD with Superscript +
**********************************************************************************/

    // Function to convert NAD+ and NAD⁺ text to NAD with superscript +
    function formatNADPlus() {
    
        // Get all text nodes in the document
        const walker = document.createTreeWalker(
            document.body,
            NodeFilter.SHOW_TEXT,
            {
                acceptNode: function(node) {
                    // Skip script and style tags
                    if (node.parentElement.tagName === 'SCRIPT' || 
                        node.parentElement.tagName === 'STYLE') {
                    return NodeFilter.FILTER_REJECT;
                    }
                    // Only process nodes that contain "NAD+" or "NAD⁺"
                    return (node.textContent.includes('NAD+') || node.textContent.includes('NAD⁺')) ? 
                    NodeFilter.FILTER_ACCEPT : 
                    NodeFilter.FILTER_REJECT;
                }
            }
        );
  
        const nodesToReplace = [];
        let node;
    
        // Collect all text nodes containing "NAD+" or "NAD⁺"
        while (node = walker.nextNode()) {
            nodesToReplace.push(node);
        }
  
        // Replace each occurrence
        nodesToReplace.forEach(textNode => {
            const parent = textNode.parentElement;
            let text = textNode.textContent;
        
            // Replace NAD⁺ with NAD+ first to normalize
            text = text.replace(/NAD⁺/g, 'NAD+');
            
            // Use regex to find and replace NAD+ while preserving exact positions
            const regex = /NAD\+/g;
            const fragment = document.createDocumentFragment();
            let lastIndex = 0;
            let match;
        
            while ((match = regex.exec(text)) !== null) {
                // Add text before the match (preserving ALL spacing exactly as-is)
                if (match.index > lastIndex) {
                    fragment.appendChild(document.createTextNode(text.substring(lastIndex, match.index)));
                }
                
                // Add "NAD" as text
                fragment.appendChild(document.createTextNode('NAD'));
                
                // Add "+" as superscript only
                const sup = document.createElement('sup');
                sup.textContent = '+';
                sup.style.fontSize = '0.75em';
                sup.style.lineHeight = '0';
                sup.style.verticalAlign = 'super';
                fragment.appendChild(sup);
                
                lastIndex = regex.lastIndex;
            }
            
            // Add any remaining text after the last match
            if (lastIndex < text.length) {
                fragment.appendChild(document.createTextNode(text.substring(lastIndex)));
            }
            
            // Replace the original text node with the new fragment
            parent.replaceChild(fragment, textNode);
        });
    }
  
    // Run on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', formatNADPlus);
    } else {
        formatNADPlus();
    }
  
    // Run again after a short delay to catch Shopify's dynamically loaded content
    setTimeout(formatNADPlus, 500);
    setTimeout(formatNADPlus, 1000);
    setTimeout(formatNADPlus, 2000);
  
    // Watch for dynamically added content (for AJAX updates, infinite scroll, etc.)
    const observer = new MutationObserver(function(mutations) {
        let shouldRun = false;

        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                // Check if any added nodes contain text
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE) {
                        shouldRun = true;
                    }
                });
            }
        });

        if (shouldRun) {
            formatNADPlus();
        }
    });
  
    // Start observing after DOM is ready
    if (document.body) {
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    } else {
        document.addEventListener('DOMContentLoaded', function() {
            observer.observe(document.body, {
            childList: true,
            subtree: true
            });
        });
    }



/******************************************************************************** 
    Rerfer Talkable Page and Menu Item Redirect 
**********************************************************************************/

    // Debug: Get user's country code when page loads
        console.log('Getting user country code...');
        fetch('https://ipapi.co/json/')
            .then(response => response.json())
            .then(data => {
                console.log('=== USER LOCATION DEBUG ===');
                console.log('Full location data:', data);
                console.log('Country code:', data.country_code);
                console.log('Country name:', data.country_name);
                console.log('City:', data.city);
                console.log('Region:', data.region);
                console.log('IP:', data.ip);
                console.log('===========================');
            })
            .catch(error => {
                console.log('Error getting location:', error);
            });

    // Refer menu redirect functionality
        document.addEventListener('click', function(e) {
            console.log('Something clicked:', e.target);
            
            const link = e.target.closest('a');
            if (!link) return;
            
            console.log('Link found:', {
                id: link.id,
                href: link.href,
                text: link.textContent.trim()
            });
            
            // Check if this is the Refer menu link
            if (link.id === 'HeaderMenu-refer' && link.href.includes('/pages/share')) {
                console.log('*** REFER LINK CLICKED ***');
                e.preventDefault(); // Prevent default navigation temporarily
                
                // Get user's country using IP geolocation
                fetch('https://ipapi.co/json/')
                    .then(response => response.json())
                    .then(data => {
                        console.log('User location data:', data);
                        const userCountry = data.country_code;
                        
                        // If user is not from US, redirect to Australian site
                        if (userCountry && userCountry !== 'US') {
                            console.log('User is not from US, redirecting to Australian site');
                            window.location.href = 'https://renuebyscience.com.au/pages/share';
                        } else {
                            console.log('User is from US, allowing normal navigation');
                            window.location.href = link.href;
                        }
                    })
                    .catch(error => {
                        console.log('Error detecting location, allowing normal navigation:', error);
                        // If geolocation fails, allow normal navigation
                        window.location.href = link.href;
                    });
            } else {
                console.log('Not the refer link, ignoring');
            }
        });



